module.exports = __webpack_public_path__ + "img/figure-27.9e492180.png";